import React, { forwardRef } from "react";
import { IconProps } from "./types";
import { defaultAttributes } from "./default-attributes";

type IconNodeElement = [
  string,
  {
    key: string;
    children?: IconNodeElement[];
    [key: string]: any;
  },
];

const createElementFromNode = (
  node: IconNodeElement,
  color: string
): React.ReactElement => {
  const [elementType, props] = node;

  if (props.children) {
    const children = Array.isArray(props.children)
      ? props.children.map((child: any) => createElementFromNode(child, color))
      : createElementFromNode(props.children, color);

    const { children: _, ...restProps } = props;
    return React.createElement(elementType, restProps, children);
  }

  const { key, ...restProps } = props;
  return React.createElement(elementType, {
    key,
    ...restProps,
    fill: restProps.fill === "currentColor" ? color : restProps.fill,
  });
};

const Icon = forwardRef<
  SVGSVGElement,
  IconProps & { iconNode: IconNodeElement[] }
>(
  (
    { color = "currentColor", size = 20, className = "", iconNode, ...props },
    ref
  ) => {
    const viewBoxSize = 20; // Warning 아이콘의 viewBox 크기
    const scale = size / viewBoxSize;

    return (
      <svg
        ref={ref}
        {...defaultAttributes}
        className={className}
        width={size}
        height={size}
        viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
        {...props}
      >
        <g
          style={{
            transform: `scale(${scale})`,
            transformOrigin: "center",
          }}
        >
          {iconNode.map((node) => createElementFromNode(node, color))}
        </g>
      </svg>
    );
  }
);

Icon.displayName = "Icon";

export default Icon;
